module.exports = __webpack_public_path__ + "img/index1.ba7099be.webp";